import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-icon-feather",
  styleUrls: ["./icon-feather.component.scss"],
  template: `
    <div class="d-flex justify-content-center align-items-center">
      <i class="feather icon-{{ icon }} {{ className }}"></i>
    </div>
  `,
})
export class IconFeatherComponent implements OnInit {
  @Input() className: string;
  @Input() icon: string;

  constructor() {}

  ngOnInit(): void {}
}
